"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "mediaQueries", {
  enumerable: true,
  get: function get() {
    return _breakpoints.mediaQueries;
  }
});
Object.defineProperty(exports, "typography", {
  enumerable: true,
  get: function get() {
    return _typography.typography;
  }
});
Object.defineProperty(exports, "fontDefinitions", {
  enumerable: true,
  get: function get() {
    return _fontDefinitions.default;
  }
});
Object.defineProperty(exports, "global", {
  enumerable: true,
  get: function get() {
    return _global.global;
  }
});
exports.default = exports.theme = void 0;

var _breakpoints = require("./variables/breakpoints");

var _colors = require("./variables/colors");

var _fonts = require("./variables/fonts");

var _space = require("./variables/space");

var _typography = require("./variables/typography");

var _fontDefinitions = _interopRequireDefault(require("./fontDefinitions"));

var _global = require("./global");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var theme = {
  breakpoints: _breakpoints.breakpoints,
  colors: _colors.colors,
  fonts: _fonts.fonts,
  fontSizes: _fonts.fontSizes,
  fontWeights: _fonts.fontWeights,
  space: _space.space,
  typography: _typography.typography,
  media: _breakpoints.media
};
exports.theme = theme;
var _default = theme;
exports.default = _default;